import Vue from 'vue'
import Vuex from 'vuex'
import lang from "../lang";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        text: lang.en,
    },
    mutations: {},
    actions: {},
    modules: {}
})
